import script from "./AppSelectDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSelectDialog.vue?vue&type=script&setup=true&lang=js"

import "./AppSelectDialog.vue?vue&type=style&index=0&id=d967ffb8&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d967ffb8"]])

export default __exports__